module.exports = __webpack_public_path__ + "static/media/client5.02a4a7e7.png";